export function jsonEqual<T, K>(a: T, b: K): boolean {
  return JSON.stringify(a) === JSON.stringify(b);
}
